import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom, switchMap, tap } from 'rxjs';
import {
  accessWeaponsApi,
  weaponsApi,
} from 'src/app/shared/constants/api.constants';
import { formatDate } from '@angular/common';
import { Toast } from '../../shared/enums/toast';
import { ActivatedRoute, Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DisclaimerComponent } from '../disclaimer/disclaimer.component';
import { HttpBaseService, ToastService } from '@evento-ng/libs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-new-request',
  templateUrl: './new-request.component.html',
  styleUrls: ['./new-request.component.scss'],
})
export class NewRequestComponent implements OnInit {
  weapons: any[] = [];
  meta: null;
  page = 1;
  currentDate;
  constructor(
    private dataService: HttpBaseService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private modalService: NgbModal,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.getMyWeapons();
    this.currentDate = formatDate(new Date(), 'dd/MM/yyyy', 'en');
  }

  getMyWeapons(): void {
    this.spinner.show();
    firstValueFrom(
      this.dataService
        .get(`${weaponsApi}/list`, {
          params: {
            page: this.page,
          },
        })
        .pipe(
          tap((res) => {
            this.spinner.hide();
            this.weapons = res.data;
            this.meta = res.meta;
          })
        )
    );
  }

  goToPage(n: number): void {
    this.page = n;
    this.getMyWeapons();
  }

  onNext(): void {
    this.page++;
    this.getMyWeapons();
  }

  onPrev(): void {
    this.page--;
    this.getMyWeapons();
  }

  openKeyModal(id: string) {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'xl',
    };

    let modalRef = this.modalService.open(DisclaimerComponent, ngbModalOptions);
    modalRef.componentInstance.agreed.subscribe(() => {
      this.request(id);
    });
  }

  request(id: string) {
    this.spinner.show();
    this.recaptchaV3Service
      .execute('createAccessRequest')
      .pipe(
        switchMap((token) => {
          const formValue = {
            weaponId: id,
          };

          return this.dataService.post(`${accessWeaponsApi}/create`, formValue);
        }),
        tap((_) => {
          this.spinner.hide();
          this.toast.show(
            'Success',
            this.translate.instant('Your request raised successfully'),
            {
              classname: Toast.success,
            }
          );
          this.router.navigate(['../my-requests'], { relativeTo: this.route });
        })
      )
      .subscribe();
  }

  protected readonly formatDate = formatDate;
}
